exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-level-1[data-v-538c49a6]  .md-list-item-text {\n  font-weight: 500;\n}\n.option-level-2[data-v-538c49a6] {\n  margin-left: 20px !important;\n}\n.option-level-3[data-v-538c49a6] {\n  margin-left: 40px !important;\n}\n", ""]);

// exports
